import { Dispatch, SetStateAction } from "react";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { COMPACT_QUERY } from "../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

const LIST_LIMIT = [10, 20, 50, 100];

interface ReportPaginationProps {
  totalCount: number;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  limit: number;
  setLimit: Dispatch<SetStateAction<number>>;
}

export default function EventLogsPagination({
  totalCount,
  page,
  setPage,
  limit,
  setLimit,
}: ReportPaginationProps) {
  const handleChangeLimit = (event: SelectChangeEvent<number>) => {
    setLimit(Number(event.target.value));
    setPage(1);
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      sx={{
        [compact]: { p: 1.5, flexWrap: "wrap", gap: 1 },
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="body2">แสดง</Typography>
        <Select size="small" value={limit} onChange={handleChangeLimit}>
          {LIST_LIMIT.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
        <Typography variant="body2">รายการ</Typography>
      </Box>
      <Pagination
        count={Math.ceil(totalCount / limit)}
        page={page}
        onChange={(_, newPage) => setPage(newPage)}
        color="primary"
        variant="outlined"
        shape="rounded"
      />
    </Box>
  );
}
